import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

/**
 * 商店列表组件
 * @param {Object} props - 组件属性
 * @param {Array} props.stores - 商店数据
 * @param {boolean} props.isVisible - 是否显示
 * @param {string} props.locale - 当前语言
 * @param {function} props.onStoreClick - 商店点击事件
 */
const StoreList = ({ 
  stores, 
  isVisible, 
  locale, 
  onStoreClick,
  styles
}) => {
  if (!stores || stores.length === 0) return null;

  return (
    <div
      className={styles.wrapMall}
      name="wrapMall"
      style={{ 
        display: isVisible ? 'inline-block' : 'none',
 
      }}
    >
      <div className={styles.mallBox}>
        {stores.map((store, index) => (
          <a
            className={styles.mallItem}
            key={`${store.name_key}-${index}`}
            href={store.link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onStoreClick}
          >
            <FormattedMessage id={store.name_key} />
          </a>
        ))}
      </div>
      <div style={{ height: 16 }}></div>
    </div>
  );
};

StoreList.propTypes = {
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      name_key: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired
    })
  ).isRequired,
  isVisible: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  onStoreClick: PropTypes.func,
  styles: PropTypes.object.isRequired
};

export default StoreList; 